import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../ui/TextField";
import DataSelect from "../../../../ui/DataSelect";
import Checkbox from "../../../../ui/Checkbox";
import { getOrganizations, getPrograms } from "../../store/actions";

const defaultData = {
  organization : null,
  program : null,
  dateStart : null,
  dateEnd : null
};

const styles = () => ({
  root: {
    "& .MuiFormLabel-root": {
      whiteSpace: "nowrap"
    },
    "& .MuiInputBase-input.Mui-disabled": {
      color: "#000"
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  block: {
    margin: "35px 0 15px 0"
  }
});

const AddPlanForm = ({
  disabled,
  onFormChange,
  classes,
  getOrganizations,
  organizations,
  getPrograms,
  programs
 }) => {
  const [data, setData] = React.useState(defaultData);
  const {organization, program, dateStart, dateEnd } = data;

  const onChange = (field, value) => {
    const newState = {
      ...data,
      [field]: value
    };

    setData(newState);
    onFormChange(newState);
  };

  React.useEffect(() => {
    getOrganizations();
  }, []);

  React.useEffect(() => {
    if (organization && organization > -1) {
      getPrograms(organization);
    }
  }, [organization]);

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          {organizations && <DataSelect
            value={organization}
            onChange={value => onChange("organization", value.id)}
            label="Подрядчик"
            dataSource={organizations}
            disabled={disabled}
            required/>}
        </Grid>
        <Grid item xs={12}>
          {programs && <DataSelect
            keyField="_key"
            value={program}
            onChange={value => onChange("program", value._key)}
            label="Программа/Модуль"
            dataSource={programs}
            disabled={disabled}
            required/>}
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            value={dateStart}
            onChange={e => onChange("dateStart", e.target.value)}
            label="Начало набора"
            format="dd.MM.yyyy"
            type="date"
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            required
            value={dateEnd}
            onChange={e => onChange("dateEnd", e.target.value)}
            label="Окончание набора"
            format="dd.MM.yyyy"
            type="date"
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => ({
  isFetchingOrganizations: state.studyPlan.isFetchingOrganizations,
  organizations: state.studyPlan.organizations,
  isFetchingPrograms: state.studyPlan.isFetchingPrograms,
  programs: state.studyPlan.programs
});

const mapDispatchToProps = dispatch => ({
  getOrganizations: () => dispatch(getOrganizations()),
  getPrograms: (orgId) => dispatch(getPrograms(orgId))
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddPlanForm));
